<template>
    <div>
        <h3>拍手ボタンを設置する</h3>
        <div>
            <p>
                小説に拍手ボタンを設置することができます。
            </p>
            <img src="/img/help/novel/22.png" alt="拍手ボタン" class="img-thumbnail mb-3">
            <p>
                マイページ＞小説管理＞本文一覧の「拍手ボタン」から、拍手ボタンを複数設定することができます。
                「面白かったです」や「続きが読みたいです」のような一般的にポジティブなボタンから、
                「★」「★★」「★★★」のような星の数を指定するもの、登場人物の名前で人気投票するなど、
                ボタンの文字列は自由に設定できます。
            </p>
            <p>
                拍手ボタンは「感想可」にすると、拍手ボタンクリック後に感想入力欄が表示されます。
                拍手だけクリックする場合もありますが、感想可にしておくことで、感想を貰える可能性があります。
            </p>
            <p>
                感想は登録ユーザーだけでなく、匿名の読者から送られてくることがあります。
                送られた感想は作者にしか見えません。これらの感想に返信することができます。
                匿名の読者からの感想に返信した場合は、その内容が一言欄に表示されます。
            </p>

            <h4>登録ユーザーからの感想</h4>
            <p>
                登録ユーザーから感想が送られてきた場合、その感想は作者と投稿したユーザーの両者のみに見えます。
                この感想に返信しても、お互いにしか見えないやりとりとなります。
            </p>
            <p>
                登録ユーザーから、不快な感想が連投される場合、そのユーザーをミュートすることができます。
                ミュートしたことは相手にはわかりません。
            </p>

            <h4>匿名の読者からの感想</h4>
            <p>
                匿名の読者から感想が送られてきた場合、その感想は作者にしか見えません。
                この感想に返信した場合、「一言欄」に感想と返信の内容が表示されます。
            </p>
            <img src="/img/help/novel/23.png" alt="感想への返信" class="img-thumbnail mb-3">
            <p>
                この表示は、一言データに感想データが紐付いているだけなので、該当する一言を削除することで、
                一言欄の表示を消すことができます。
                感想の一言を削除しても、感想そのものは削除されません。
                一言欄から削除した感想を再投稿したい場合、返信内容を少し修正して更新することで、
                新たに感想の一言が投稿されます。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "拍手ボタンを設置する | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>